<template>
  <!-- In this template, we are applying spacing horizontal classes to each section because we want the Gallery section to be scrollable from end to end in mobile device  -->
  <div class="fe-spacing-vertical">
    <div class="fe-mb-m fe-spacing-horizontal">
      <RatingSummary />
    </div>
    <div class="fe-mb-m fe-spacing-horizontal">
      <RatingCta />
    </div>

    <div class="fe-mb-m fe-spacing-horizontal">
      <MyReviewList />
    </div>

    <div class="fe-mb-m">
      <GalleryList />
    </div>

    <div class="fe-spacing-horizontal">
      <ReviewList :initial-items="3" />
    </div>
  </div>
</template>

<script>
  import RatingSummary from "@/components/ReviewAndRating/RatingSummary/RatingSummary.vue"
  import RatingCta from "@/components/ReviewAndRating/RatingCta/RatingCta.vue"
  import GalleryList from "@/components/ReviewAndRating/Gallery/GalleryList.vue"
  import ReviewList from "@/components/ReviewAndRating/ReviewList/ReviewList.vue"
  import MyReviewList from "@/components/ReviewAndRating/ReviewList/MyReviewList.vue"

  export default {
    name: "LayoutOneMobile",
    components: {
      RatingSummary,
      RatingCta,
      MyReviewList,
      ReviewList,
      GalleryList,
    },
  }
</script>
